const chatFlowBuiltInTypes = [
  'age',
  'currency',
  'date',
  'datetime',
  'daterange',
  'dimension',
  'duration',
  'email',
  'hashtag',
  'ip',
  'number',
  'ordinal',
  'percentage',
  'phonenumber',
  'time',
  'url',
];

export default chatFlowBuiltInTypes;
